/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import DynamicFieldsFragment from '@linc-technologies/linced-common/models/dynamic-field/base-fragment';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: enrolments.Contact.
export default class Contact extends DynamicFieldsFragment {
  declare [Type]: 'enrolments/contact';

  @attr('number', { defaultValue: 0 })
  declare type: number;

  @attr('number', { defaultValue: 0 })
  declare relationship: number;

  @attr('number', { defaultValue: 0 })
  declare medicalRelationship: number;

  @attr('string', { defaultValue: '' })
  declare notes: string;

  @attr('boolean', { defaultValue: false })
  declare receivesSms: boolean;

  @attr('boolean', { defaultValue: false })
  declare billPayer: boolean;

  @attr('boolean', { defaultValue: false })
  declare permissionToContact: boolean;

  @computed('fields.{core:firstName.value,core:lastName.value}')
  get hasName() {
    const firstName =
      (this.get('fields.core:firstName.value') as string | undefined) || '';
    const lastName =
      (this.get('fields.core:lastName.value') as string | undefined) || '';
    const name = `${firstName} ${lastName}`.trim();
    return name.length > 0;
  }
}
